import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import TeamPage from '@src/pages/Team';

export const Route = createFileRoute('/team')({
  head: () => buildSeoHead({ path: '/team', ...ROUTE_META['/team'] }),
  component: TeamPageWithLayout,
});

function TeamPageWithLayout() {
  return (
    <DefaultLayout>
      <TeamPage />
    </DefaultLayout>
  );
}
